import Decimal from 'decimal.js';

export default function calculateAspectRatio(width, height) {
  if (typeof width !== 'number' || Number.isNaN(width) || width <= 0 || typeof height !== 'number' || Number.isNaN(height) || height <= 0) {
    throw new Error('Width and height must be provided and non-zero.');
  }
  const widthDecimal = new Decimal(width);
  const heightDecimal = new Decimal(height);
  // Return a Decimal, not a number or string
  return widthDecimal.div(heightDecimal).toDecimalPlaces(2);
}
